import React, { useEffect, createElement } from 'react';
import { ShieldAlertIcon, CpuIcon, MonitorIcon, FileSearchIcon, ActivityIcon, GlobeIcon, LockIcon, ZapIcon, ServerIcon, BarChart3Icon, AlertTriangleIcon, CheckCircle2Icon, DownloadIcon, ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function QuasarPlatform() {
  // Set page-specific meta tags
  useEffect(() => {
    // Store original values for cleanup
    const originalTitle = document.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogType = document.querySelector('meta[property="og:type"]');
    const ogImage = document.querySelector('meta[property="og:image"]');
    const ogImageAlt = document.querySelector('meta[property="og:image:alt"]');
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    const twitterImageAlt = document.querySelector('meta[name="twitter:image:alt"]');
    const canonical = document.querySelector('link[rel="canonical"]');
    const origDesc = metaDescription?.getAttribute('content') || '';
    const origKeywords = metaKeywords?.getAttribute('content') || '';
    const origOgTitle = ogTitle?.getAttribute('content') || '';
    const origOgDesc = ogDescription?.getAttribute('content') || '';
    const origOgUrl = ogUrl?.getAttribute('content') || '';
    const origOgType = ogType?.getAttribute('content') || '';
    const origOgImage = ogImage?.getAttribute('content') || '';
    const origOgImageAlt = ogImageAlt?.getAttribute('content') || '';
    const origTwitterTitle = twitterTitle?.getAttribute('content') || '';
    const origTwitterDesc = twitterDescription?.getAttribute('content') || '';
    const origTwitterImage = twitterImage?.getAttribute('content') || '';
    const origTwitterImageAlt = twitterImageAlt?.getAttribute('content') || '';
    const origCanonical = canonical?.getAttribute('href') || '';
    // Update title
    document.title = 'Quasar - Web Engineering & Cyber Defense Platform | COSMO IMAGE AVIATION';
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Quasar Web Engineering Platform: Advanced cyber defense solution for real-time threat detection, automated defense playbooks, vulnerability scanning, and AI-powered endpoint integration. Built for military and government cyber squadrons.');
    }
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Quasar platform, web engineering, cyber defense, threat detection, vulnerability scanning, DDoS simulation, automated defense, endpoint integration, cybersecurity, military cyber, COSMO IMAGE AVIATION');
    }
    if (ogTitle) ogTitle.setAttribute('content', 'Quasar - Web Engineering & Cyber Defense Platform');
    if (ogDescription) ogDescription.setAttribute('content', 'Advanced cyber defense platform for real-time threat detection, automated defense playbooks, vulnerability scanning, and AI-powered endpoint integration for military and government cyber operations.');
    if (ogUrl) ogUrl.setAttribute('content', 'https://www.cosmoimageaviation.com/quasar');
    if (ogType) ogType.setAttribute('content', 'product');
    if (ogImage) ogImage.setAttribute('content', 'https://cdn.magicpatterns.com/uploads/ogMMqjpkRY984JdTJxFSeg/Screenshot_2026-02-25_222146.png');
    if (ogImageAlt) ogImageAlt.setAttribute('content', 'Quasar Web Engineering Platform Interface');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Quasar - Web Engineering & Cyber Defense Platform');
    if (twitterDescription) twitterDescription.setAttribute('content', 'Advanced cyber defense platform for real-time threat detection, automated defense playbooks, and AI-powered endpoint integration.');
    if (twitterImage) twitterImage.setAttribute('content', 'https://cdn.magicpatterns.com/uploads/ogMMqjpkRY984JdTJxFSeg/Screenshot_2026-02-25_222146.png');
    if (twitterImageAlt) twitterImageAlt.setAttribute('content', 'Quasar Web Engineering Platform Interface');
    if (canonical) canonical.setAttribute('href', 'https://www.cosmoimageaviation.com/quasar');
    const ogImageWidth = document.querySelector('meta[property="og:image:width"]');
    const ogImageHeight = document.querySelector('meta[property="og:image:height"]');
    const origOgImageWidth = ogImageWidth?.getAttribute('content') || '';
    const origOgImageHeight = ogImageHeight?.getAttribute('content') || '';
    if (ogImageWidth) ogImageWidth.setAttribute('content', '1920');
    if (ogImageHeight) ogImageHeight.setAttribute('content', '1080');
    const ogImageSecureUrl = document.querySelector('meta[property="og:image:secure_url"]');
    const origOgImageSecureUrl = ogImageSecureUrl?.getAttribute('content') || '';
    if (ogImageSecureUrl) ogImageSecureUrl.setAttribute('content', 'https://cdn.magicpatterns.com/uploads/ogMMqjpkRY984JdTJxFSeg/Screenshot_2026-02-25_222146.png');
    const ogImageType = document.querySelector('meta[property="og:image:type"]');
    const origOgImageType = ogImageType?.getAttribute('content') || '';
    if (ogImageType) ogImageType.setAttribute('content', 'image/png');
    // Add page-specific JSON-LD structured data
    const jsonLd = document.createElement('script');
    jsonLd.type = 'application/ld+json';
    jsonLd.id = 'quasar-jsonld';
    jsonLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'Quasar Web Engineering Platform',
      applicationCategory: 'SecurityApplication',
      operatingSystem: 'Web',
      description: 'Advanced cyber defense platform providing real-time threat detection, automated defense playbooks, vulnerability scanning, web intrusion simulation tools, and AI-powered endpoint integration for military and government cyber squadrons.',
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: 'USD',
        seller: {
          '@type': 'Organization',
          name: 'COSMO IMAGE AVIATION PTE. LTD.',
          url: 'https://www.cosmoimageaviation.com/'
        }
      },
      featureList: 'Security Health Radar, Active Threat List, URL Monitoring, Web Intrusion Tools, AI Support & Endpoint Integration, Automated Defense Playbooks',
      screenshot: 'https://cdn.magicpatterns.com/uploads/1D9MxDFKNEeenQvHjPU8AT/Screenshot_2026-02-25_222235.png',
      provider: {
        '@type': 'Organization',
        name: 'COSMO IMAGE AVIATION PTE. LTD.',
        url: 'https://www.cosmoimageaviation.com/'
      }
    });
    document.head.appendChild(jsonLd);
    // Add BreadcrumbList JSON-LD
    const breadcrumbLd = document.createElement('script');
    breadcrumbLd.type = 'application/ld+json';
    breadcrumbLd.id = 'quasar-breadcrumb';
    breadcrumbLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.cosmoimageaviation.com/'
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'Products',
        item: 'https://www.cosmoimageaviation.com/#services'
      }, {
        '@type': 'ListItem',
        position: 3,
        name: 'Quasar Platform',
        item: 'https://www.cosmoimageaviation.com/quasar'
      }]
    });
    document.head.appendChild(breadcrumbLd);
    window.scrollTo(0, 0);
    return () => {
      document.title = originalTitle;
      if (metaDescription) metaDescription.setAttribute('content', origDesc);
      if (metaKeywords) metaKeywords.setAttribute('content', origKeywords);
      if (ogTitle) ogTitle.setAttribute('content', origOgTitle);
      if (ogDescription) ogDescription.setAttribute('content', origOgDesc);
      if (ogUrl) ogUrl.setAttribute('content', origOgUrl);
      if (ogType) ogType.setAttribute('content', origOgType);
      if (ogImage) ogImage.setAttribute('content', origOgImage);
      if (ogImageAlt) ogImageAlt.setAttribute('content', origOgImageAlt);
      if (ogImageWidth) ogImageWidth.setAttribute('content', origOgImageWidth);
      if (ogImageHeight) ogImageHeight.setAttribute('content', origOgImageHeight);
      if (twitterTitle) twitterTitle.setAttribute('content', origTwitterTitle);
      if (twitterDescription) twitterDescription.setAttribute('content', origTwitterDesc);
      if (twitterImage) twitterImage.setAttribute('content', origTwitterImage);
      if (twitterImageAlt) twitterImageAlt.setAttribute('content', origTwitterImageAlt);
      if (canonical) canonical.setAttribute('href', origCanonical);
      if (ogImageSecureUrl) ogImageSecureUrl.setAttribute('content', origOgImageSecureUrl);
      if (ogImageType) ogImageType.setAttribute('content', origOgImageType);
      document.getElementById('quasar-jsonld')?.remove();
      document.getElementById('quasar-breadcrumb')?.remove();
    };
  }, []);
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-white/20" data-id="element-282">
      <Header data-id="element-283" />

      {/* Hero Section */}
      <section className="relative pt-40 pb-32 px-6 bg-navy overflow-hidden isolate" data-id="element-284">
        <div className="container mx-auto max-w-[var(--maxw)] relative z-10" data-id="element-285">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-286">
            <div className="lg:w-1/2 text-center lg:text-left" data-id="element-287">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-light mb-8 text-white tracking-tight" data-id="element-288">
                <span className="font-bold" data-id="element-289">Quasar</span> Platform
              </h1>

              <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed font-light" data-id="element-290">
                Cyber defense today isn't about building taller walls — it's
                about achieving situational dominance in a digital battlespace
              </p>

              <p className="text-gray-400 text-lg max-w-xl mx-auto lg:mx-0 mb-12 font-light" data-id="element-291">
                Web Engineering Platform help the squadron spot threats quickly,
                test defenses safely, and respond fast with automated actions.
              </p>

              <div className="flex flex-col sm:flex-row gap-6 justify-center lg:justify-start" data-id="element-292">
                <button onClick={() => {
                const section = document.getElementById('features-section');
                if (section) section.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300" data-id="element-293">
                  View Features
                </button>
                <a href="https://drive.google.com/drive/folders/1q38GvvnFWDCRppt3rAnzCdkgT3tmDTrV?usp=sharing" target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-294">
                  <DownloadIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-295" />
                  Download Brochure
                </a>
              </div>
            </div>

            <div className="lg:w-1/2 w-full" data-id="element-296">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-2 rounded-2xl shadow-2xl overflow-hidden" data-id="element-297">
                <img src="https://cdn.magicpatterns.com/uploads/ogMMqjpkRY984JdTJxFSeg/Screenshot_2026-02-25_222146.png" alt="Quasar Botnet Architecture Diagram" className="w-full h-auto rounded-xl" data-id="element-298" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* From Threat to Control Section */}
      <section id="features-section" className="py-32 bg-surface" data-id="element-299">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-300">
          <div className="text-center mb-20" data-id="element-301">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-white tracking-tight" data-id="element-302">
              <span className="font-light" data-id="element-303">"From Threat to Control—</span>
              <span className="font-bold" data-id="element-304">Fast"</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-305">
            {/* Feature 1 */}
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl flex flex-col sm:flex-row gap-8" data-id="element-306">
              <div className="flex-shrink-0" data-id="element-307">
                <div className="w-14 h-14 border border-white/20 rounded-full flex items-center justify-center" data-id="element-308">
                  <FileSearchIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-309" />
                </div>
              </div>
              <div data-id="element-310">
                <h3 className="text-xl font-medium text-white mb-4" data-id="element-311">
                  Enhance Situational Awareness
                </h3>
                <ul className="space-y-4 text-gray-400 font-light" data-id="element-312">
                  <li className="flex items-start gap-4" data-id="element-313">
                    <span className="text-white/30 mt-1" data-id="element-314">—</span>
                    <span data-id="element-315">
                      Deliver real-time visibility of ongoing threats, system
                      health, and attack surfaces.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-316">
                    <span className="text-white/30 mt-1" data-id="element-317">—</span>
                    <span data-id="element-318">
                      Enable leadership to make faster, data-driven operational
                      decisions.
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl flex flex-col sm:flex-row gap-8" data-id="element-319">
              <div className="flex-shrink-0" data-id="element-320">
                <div className="w-14 h-14 border border-white/20 rounded-full flex items-center justify-center" data-id="element-321">
                  <ActivityIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-322" />
                </div>
              </div>
              <div data-id="element-323">
                <h3 className="text-xl font-medium text-white mb-4" data-id="element-324">
                  Automate Defense Playbooks
                </h3>
                <ul className="space-y-4 text-gray-400 font-light" data-id="element-325">
                  <li className="flex items-start gap-4" data-id="element-326">
                    <span className="text-white/30 mt-1" data-id="element-327">—</span>
                    <span data-id="element-328">
                      Replace manual, reactive response with automated,
                      rule-based workflows.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-329">
                    <span className="text-white/30 mt-1" data-id="element-330">—</span>
                    <span data-id="element-331">
                      Ensure consistency and precision even under high
                      operational tempo.
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl flex flex-col sm:flex-row gap-8" data-id="element-332">
              <div className="flex-shrink-0" data-id="element-333">
                <div className="w-14 h-14 border border-white/20 rounded-full flex items-center justify-center" data-id="element-334">
                  <MonitorIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-335" />
                </div>
              </div>
              <div data-id="element-336">
                <h3 className="text-xl font-medium text-white mb-4" data-id="element-337">
                  Train and Test Through Realistic Simulations
                </h3>
                <ul className="space-y-4 text-gray-400 font-light" data-id="element-338">
                  <li className="flex items-start gap-4" data-id="element-339">
                    <span className="text-white/30 mt-1" data-id="element-340">—</span>
                    <span data-id="element-341">
                      Provide a safe environment to simulate DDoS, intrusion,
                      and exploit scenarios.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-342">
                    <span className="text-white/30 mt-1" data-id="element-343">—</span>
                    <span data-id="element-344">
                      Strengthen the squadron's readiness through measurable
                      exercises — not theory.
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Feature 4 */}
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl flex flex-col sm:flex-row gap-8" data-id="element-345">
              <div className="flex-shrink-0" data-id="element-346">
                <div className="w-14 h-14 border border-white/20 rounded-full flex items-center justify-center" data-id="element-347">
                  <CpuIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-348" />
                </div>
              </div>
              <div data-id="element-349">
                <h3 className="text-xl font-medium text-white mb-4" data-id="element-350">
                  Integrate Intelligence and Action
                </h3>
                <ul className="space-y-4 text-gray-400 font-light" data-id="element-351">
                  <li className="flex items-start gap-4" data-id="element-352">
                    <span className="text-white/30 mt-1" data-id="element-353">—</span>
                    <span data-id="element-354">
                      Connect data from multiple sensors, endpoints, and threat
                      feeds.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-355">
                    <span className="text-white/30 mt-1" data-id="element-356">—</span>
                    <span data-id="element-357">
                      Turn threat intelligence into actionable defense measures,
                      instantly.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dashboard Section */}
      <section className="py-32 bg-navy" data-id="element-358">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-359">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-360">
            <div className="lg:w-1/2 w-full" data-id="element-361">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-2 rounded-2xl shadow-2xl overflow-hidden" data-id="element-362">
                <img src="https://cdn.magicpatterns.com/uploads/1D9MxDFKNEeenQvHjPU8AT/Screenshot_2026-02-25_222235.png" alt="Quasar Dashboard Interface" className="w-full h-auto rounded-xl" data-id="element-363" />
              </div>
            </div>
            <div className="lg:w-1/2" data-id="element-364">
              <h2 className="text-4xl md:text-5xl font-light mb-6 text-white tracking-tight" data-id="element-365">
                <span className="font-bold" data-id="element-366">Dashboard</span>
              </h2>
              <p className="text-xl text-gray-400 font-light mb-12" data-id="element-367">
                Displays overall security posture and active threats in real
                time
              </p>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-368">
                <h3 className="text-xl font-medium text-white border-b border-white/10 pb-4 mb-6" data-id="element-369">
                  Key Features
                </h3>
                <ul className="space-y-6" data-id="element-370">
                  <li className="flex items-start gap-4" data-id="element-371">
                    <span className="text-white/30 mt-1" data-id="element-372">—</span>
                    <span className="text-gray-400 font-light" data-id="element-373">
                      <strong className="text-white font-medium" data-id="element-374">
                        Security Health Radar
                      </strong>{' '}
                      — visual summary of five key security domains
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-375">
                    <span className="text-white/30 mt-1" data-id="element-376">—</span>
                    <span className="text-gray-400 font-light" data-id="element-377">
                      <strong className="text-white font-medium" data-id="element-378">
                        Active Threat List
                      </strong>{' '}
                      — ongoing incidents with severity, affected systems, and
                      recommendations
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-379">
                    <span className="text-white/30 mt-1" data-id="element-380">—</span>
                    <span className="text-gray-400 font-light" data-id="element-381">
                      <strong className="text-white font-medium" data-id="element-382">
                        Threat Summary Metrics
                      </strong>{' '}
                      — total threats, active threats, protected endpoints
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* URL Monitoring Section */}
      <section className="py-32 bg-surface" data-id="element-383">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-384">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-16" data-id="element-385">
            <div className="lg:w-1/2 w-full" data-id="element-386">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-2 rounded-2xl shadow-2xl overflow-hidden" data-id="element-387">
                <img src="https://cdn.magicpatterns.com/uploads/18dQXhhiBPLeU6jCft4C47/Screenshot_2026-02-25_222243.png" alt="URL Monitoring Interface" className="w-full h-auto rounded-xl" data-id="element-388" />
              </div>
            </div>
            <div className="lg:w-1/2" data-id="element-389">
              <h2 className="text-4xl md:text-5xl font-light mb-6 text-white tracking-tight" data-id="element-390">
                <span className="font-bold" data-id="element-391">URL</span> Monitoring
              </h2>
              <p className="text-xl text-gray-400 font-light mb-12" data-id="element-392">
                Domain-based vulnerability scanning module
              </p>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-393">
                <h3 className="text-xl font-medium text-white border-b border-white/10 pb-4 mb-6" data-id="element-394">
                  Key Features
                </h3>
                <ul className="space-y-6" data-id="element-395">
                  <li className="flex items-start gap-4" data-id="element-396">
                    <span className="text-white/30 mt-1" data-id="element-397">—</span>
                    <span className="text-gray-400 font-light" data-id="element-398">
                      URL input and vulnerability scoring (Low—Medium—High)
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-399">
                    <span className="text-white/30 mt-1" data-id="element-400">—</span>
                    <span className="text-gray-400 font-light" data-id="element-401">
                      Severity-level breakdown (High / Medium / Low)
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-402">
                    <span className="text-white/30 mt-1" data-id="element-403">—</span>
                    <span className="text-gray-400 font-light" data-id="element-404">
                      Port and network service configuration view
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Web Intrusion Tools Section */}
      <section className="py-32 bg-navy" data-id="element-405">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-406">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-407">
            <div className="lg:w-1/2 w-full" data-id="element-408">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-2 rounded-2xl shadow-2xl overflow-hidden" data-id="element-409">
                <img src="https://cdn.magicpatterns.com/uploads/e6rvaAQoeZuREr8cQvqhvr/Screenshot_2026-02-25_222256.png" alt="Web Intrusion Tools Interface" className="w-full h-auto rounded-xl" data-id="element-410" />
              </div>
            </div>
            <div className="lg:w-1/2" data-id="element-411">
              <h2 className="text-4xl md:text-5xl font-light mb-6 text-white tracking-tight" data-id="element-412">
                <span className="font-bold" data-id="element-413">Web Intrusion</span> Tools
              </h2>
              <p className="text-xl text-gray-400 font-light mb-12" data-id="element-414">
                Controlled environment to simulate and observe attack resilience
              </p>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl mb-10" data-id="element-415">
                <h3 className="text-xl font-medium text-white border-b border-white/10 pb-4 mb-6" data-id="element-416">
                  Key Features
                </h3>
                <ul className="space-y-6" data-id="element-417">
                  <li className="flex items-start gap-4" data-id="element-418">
                    <span className="text-white/30 mt-1" data-id="element-419">—</span>
                    <span className="text-gray-400 font-light" data-id="element-420">
                      Live Console — real-time logs of HTTP requests, agents,
                      and response rates
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-421">
                    <span className="text-white/30 mt-1" data-id="element-422">—</span>
                    <span className="text-gray-400 font-light" data-id="element-423">
                      Exploit Trends Chart — attack trend visualization over
                      time
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-424">
                    <span className="text-white/30 mt-1" data-id="element-425">—</span>
                    <span className="text-gray-400 font-light" data-id="element-426">
                      Network Attack Surface — IP list with vulnerability scores
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-427">
                    <span className="text-white/30 mt-1" data-id="element-428">—</span>
                    <span className="text-gray-400 font-light" data-id="element-429">
                      Layer 7 Application Level Flooding
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-430">
                    <span className="text-white/30 mt-1" data-id="element-431">—</span>
                    <span className="text-gray-400 font-light" data-id="element-432">
                      Automatic Bypass Cloudflare
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-16 bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-433">
            <h3 className="text-xl font-medium text-white mb-6" data-id="element-434">Limitations</h3>
            <ul className="space-y-6" data-id="element-435">
              <li className="flex items-start gap-4" data-id="element-436">
                <AlertTriangleIcon className="w-6 h-6 text-white/50 flex-shrink-0 mt-1" strokeWidth={1.5} data-id="element-437" />
                <span className="text-gray-400 font-light" data-id="element-438">
                  Websites protected by DDOS Protection like Imperva, Ddos
                  Guard, Akamai, Arbour, F5 and others cannot be bypassed
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-439">
                <AlertTriangleIcon className="w-6 h-6 text-white/50 flex-shrink-0 mt-1" strokeWidth={1.5} data-id="element-440" />
                <span className="text-gray-400 font-light" data-id="element-441">
                  The system is not designed to attack industry giants who has
                  high security protection such as Facebook / Meta Group,
                  Google, Twitter (X), Instagram, TikTok, CNN, Detik.com, or
                  online media hosted on AWS Cloud, Google Cloud, Alibaba Cloud,
                  and other major hosting providers.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* AI Support & Endpoint Integration Section */}
      <section className="py-32 bg-surface" data-id="element-442">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-443">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-16" data-id="element-444">
            <div className="lg:w-1/2 w-full" data-id="element-445">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-2 rounded-2xl shadow-2xl overflow-hidden" data-id="element-446">
                <img src="https://cdn.magicpatterns.com/uploads/78vsw7TPQuD3G7mENuZGZM/Screenshot_2026-02-25_222308.png" alt="AI Support & Endpoint Integration Interface" className="w-full h-auto rounded-xl" data-id="element-447" />
              </div>
            </div>
            <div className="lg:w-1/2" data-id="element-448">
              <h2 className="text-4xl md:text-5xl font-light mb-6 text-white tracking-tight" data-id="element-449">
                <span className="font-bold" data-id="element-450">AI Support</span> & Endpoint
                Integration
              </h2>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl mt-12" data-id="element-451">
                <h3 className="text-xl font-medium text-white border-b border-white/10 pb-4 mb-6" data-id="element-452">
                  Key Features
                </h3>
                <ul className="space-y-6" data-id="element-453">
                  <li className="flex items-start gap-4" data-id="element-454">
                    <span className="text-white/30 mt-1" data-id="element-455">—</span>
                    <span className="text-gray-400 font-light" data-id="element-456">
                      AI-driven threat analysis and endpoint coordination
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-457">
                    <span className="text-white/30 mt-1" data-id="element-458">—</span>
                    <span className="text-gray-400 font-light" data-id="element-459">
                      Supports automatic incident correlation and remediation
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-navy text-center" data-id="element-460">
        <div className="container mx-auto max-w-4xl px-6" data-id="element-461">
          <h2 className="text-3xl md:text-5xl font-light text-white mb-8" data-id="element-462">
            <span className="font-bold" data-id="element-463">Ready to Strengthen</span> Your Cyber
            Defense?
          </h2>
          <p className="text-xl text-gray-400 font-light mb-12" data-id="element-464">
            Contact us for a demo and further consultation on the Quasar
            platform.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-465">
            <a href="mailto:contact@cosmoimageaviation.co" className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300" data-id="element-466">
              Contact Us
            </a>
            <a href="https://drive.google.com/drive/folders/1q38GvvnFWDCRppt3rAnzCdkgT3tmDTrV?usp=sharing" target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-467">
              <DownloadIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-468" />
              Download Brochure
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-469" />
    </div>;
}